
import Swiper, {Navigation, Pagination, EffectFade} from "swiper";
import PerfectScrollbar from "perfect-scrollbar";
import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";
    
/** Класс создания слайдера для прохождения профтеста. */
class CareerGuidanceTestModal {
    documentEl = document.body

    swiper

    swiperWrapper

    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.elementScrollbar = this.el.querySelector(".js-scrollbar-card");
        this.resultProftestScrollbar = this.el.querySelector(".js-scrollbar-result-proftest");
        this.sliderElement = this.el.querySelector(".js-proftest-slider");
        this.modal = this.documentEl.querySelector(".js-modal-proftest");
        this.openModalButton = document.querySelector(".js-open-proftest-modal");
        this.proftestWrap = this.el.querySelector(".js-proftest-wrap");
        this.proftestForm = this.el.querySelector(".js-proftest-form");
        this.submitButton = this.proftestForm.querySelector(".js-form-submit-btn");
        this.inputs = this.proftestForm.querySelectorAll(".proftest__data input"); 
        this.inputName = this.proftestForm.querySelector(".js-proftest-name");
        this.inputPhone = this.proftestForm.querySelector(".js-proftest-phone");
        this.pagination = this.el.querySelector(".js-proftest-pagination");
        this.navigation = this.el.querySelector(".proftest__navigation");
        
        this.createScrollbar();
        this.enableSlider();
        this.bindEventListeners();
    }

    /**
     * Прослушиваем события.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        this.openModalButton.addEventListener("click", () => {
            this.modal.classList.add("shown");
            ToggleScroll.disable(this.modal);
            focusManager.capture(this.modal);
        });

        this.swiper.on("slideChange", () => {
            if (this.swiper.activeIndex !== 0) {
                this.proftestWrap?.classList.add("is-next");
            } else {
                this.proftestWrap?.classList.remove("is-next");
            }

            const activeSlide = this.swiper.slides[this.swiper.activeIndex];
            const radioInputs = activeSlide.querySelectorAll("input");
            radioInputs.forEach(input => {
                input.removeAttribute("checked");
            })
        });

        document.addEventListener("click", (event) => {
            if (event.target.classList.contains("radio-button") || 
            event.target.closest(".radio-button")) {
                const indexLastSlide = this.swiper.slides.length - 1;
                if (this.swiper.activeIndex === indexLastSlide) {
                    this.sliderElement.classList.add("hidden");
                    this.pagination.classList.add("hidden");
                    this.navigation.classList.add("hidden");
                    this.sliderElement.nextElementSibling.classList.remove("hidden");
                }

                this.swiper.slideNext(); 
            }
        });

        this.inputs.forEach(input => {
            input.addEventListener("input", () => {
                if (this.inputName.value !== "" && this.inputPhone.value !== "" && this.inputPhone.value.length == 18) {
                    this.submitButton.removeAttribute("disabled");
                } else {
                    this.submitButton.setAttribute("disabled", "disabled");
                }
            })
        })
    }

    /**
     * Создание стилизованного скроллбара для модального окна.
     * 
     * @returns {void}
     */
    createScrollbar() {
        new PerfectScrollbar(this.elementScrollbar, {
            suppressScrollX: true,
            wheelPropagation: false,
            handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
        });

        new PerfectScrollbar(this.resultProftestScrollbar, {
            suppressScrollX: true,
            wheelPropagation: false,
            handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
        });
    }

    /**
     * Открытие модального окна.
     * 
     * @returns {void}
     */
    showModal = () => {    
        this.el.classList.add("shown");
        ToggleScroll.disable(this.el);
    }

    /**
     * Инициализация слайдера.
     * 
     * @returns {void}
     */
    enableSlider() {
        this.swiper = new Swiper(this.sliderElement, {
            modules: [Navigation, Pagination, EffectFade],
            slidesPerView: 1,
            autoHeight: true,
            allowTouchMove: false,
            noSwipingSelector: ".ts-dropdown",
            keyboard: {
                enabled: true,
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: ".js-proftest-nav-next",
                prevEl: ".js-proftest-nav-prev",
            },
            pagination: {
                el: ".js-proftest-pagination",
                type: "fraction",
            },
        });
    }
}
    
window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-proftest")
        .forEach(slider => new CareerGuidanceTestModal(slider));
});
